import * as React from 'react';

let CareerContainer: React.ComponentType | null = null;
let CareerVacanciesContainer: React.ComponentType | null = null;
let CareerVacancyContainer: React.ComponentType | null = null;
let loading: Promise<void> | null = null;

export const loadCareerPage = (): Promise<void> => {
  if (!loading) {
    loading = Promise.all([
      import(/* webpackChunkName: "career" */ '../shared/containers/Career/CareerContainer'),
      import(/* webpackChunkName: "career" */ '../shared/containers/CareerVacancies/CareerVacanciesContainer'),
      import(/* webpackChunkName: "career" */ '../shared/containers/CareerVacancy/CareerVacancyContainer'),
    ]).then(([career, vacancies, vacancy]) => {
      CareerContainer = career.CareerContainer;
      CareerVacanciesContainer = vacancies.CareerVacanciesContainer;
      CareerVacancyContainer = vacancy.CareerVacancyContainer;
    });
  }

  return loading;
};

export const CareerPage: React.FC = () => {
  if (!CareerContainer) {
    throw new Error('Career page must be loaded before hydration');
  }

  return <CareerContainer />;
};

export const CareerVacanciesPage: React.FC = () => {
  if (!CareerVacanciesContainer) {
    throw new Error('Career vacancies page must be loaded before hydration');
  }

  return <CareerVacanciesContainer />;
};

export const CareerVacancyPage: React.FC = () => {
  if (!CareerVacancyContainer) {
    throw new Error('Career vacancy page must be loaded before hydration');
  }

  return <CareerVacancyContainer />;
};
